import React from 'react';
import { IconButton } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

interface Props {
    handleClose: () => void;
}

const CloseIcon = ({ handleClose }: Props) => {
    return (
        <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
                position: 'absolute',
                right: 0,
                top: 0,
                margin: '8px',
                width: '50px',
                height: '50px',
                cursor: 'pointer',
            }}
        >
            <FontAwesomeIcon icon={faTimes} style={{ cursor: 'pointer' }}/>
        </IconButton>
    );
};

export default CloseIcon;
